
export default {
  head() {
    return {
      title:
        "Agence Google Ads | SEA à Ivry-sur-Seine dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Ivry-sur-Seine certifiée Google Partner, accompagne les entreprises ivryennes pour gagner en visibilité en ligne et générer davantage de prospects.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Agence Google Ads à Ivry-sur-Seine dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Ivry-sur-Seine certifiée Google Partner, accompagne les entreprises ivryennes pour gagner en visibilité en ligne et générer davantage de prospects.",
        },
      ],
    };
  },
};
